<page-content *ngIf="destinationPackages && !isLoading">

  <div class="container">
    <mat-form-field><input [(ngModel)]="myPackage.title" matInput placeholder="Title" required></mat-form-field>
    <mat-form-field><input [(ngModel)]="myPackage.linkName" matInput placeholder="Link name" required></mat-form-field>
    <smart-input [(model)]="myPackage" key="linkNames"></smart-input>
    <smart-input [(model)]="myPackage" key="autoUpdateInterval" [hideDescription]="true"></smart-input>
    <div>
      <div class="field-button-container">
        <mat-form-field><input [(ngModel)]="myPackage.OwnerOrganisationID" disabled matInput placeholder="OwnerOrganisationID"></mat-form-field>
        <button (click)="removeOwnerOrganisation()" *ngIf="ownerOrganisation" mat-icon-button><mat-icon>delete</mat-icon></button>
        <button (click)="assignOwnerOrganisation()" mat-icon-button><mat-icon>edit</mat-icon></button>
      </div>
      <div class="content" *ngIf="ownerOrganisation">Owner Organisation: {{ customer }}</div>
    </div>
    <div>
      <div class="field-button-container">
        <mat-form-field><input [(ngModel)]="myPackage.customerId" disabled matInput placeholder="Customer ID"></mat-form-field>
        <button (click)="removeAssignedCustomer()" *ngIf="customer" mat-icon-button><mat-icon>delete</mat-icon></button>
        <button (click)="assignCustomer()" mat-icon-button><mat-icon>edit</mat-icon></button>
      </div>
      <div class="content" *ngIf="customer">Assigned Customer: {{ customer }}</div>
    </div>
    <div><mat-checkbox *ngIf="superadmin" [(ngModel)]="myPackage.longRunning"> Is it a long running Package?</mat-checkbox></div>
    <div><mat-checkbox *ngIf="superadmin" [(ngModel)]="myPackage.isScreenPackage"> Is it a screen Package?</mat-checkbox></div>
    <div><mat-checkbox *ngIf="superadmin" [(ngModel)]="myPackage.tweebie.isDestination"> Is it a destination package?</mat-checkbox></div>
    <div><mat-checkbox *ngIf="superadmin" [(ngModel)]="myPackage.isMasterPackage"> Is it a master Package?</mat-checkbox></div>
    <div><mat-checkbox *ngIf="superadmin" [(ngModel)]="myPackage.tweebie.isFree"> Is it a free accommodation Package?</mat-checkbox></div>
    <div><mat-checkbox *ngIf="superadmin" [(ngModel)]="myPackage.underConstruction"> Is the package under construction?</mat-checkbox></div>
    <div><mat-checkbox *ngIf="superadmin" [(ngModel)]="myPackage.isNotTouch2015ScreenPackage"> Is it a new package (no Touch2015)?</mat-checkbox></div>
    <mat-form-field *ngIf="myPackage.isScreenPackage && myPackage.screen"><input [(ngModel)]="myPackage.screen.QRCode" matInput placeholder="Link for QR-Code touch2go"></mat-form-field>
    <smart-input [(model)]="myPackage" [hideDescription]="true" key="additionalFrontProfileFields"></smart-input>
    <smart-input [(model)]="myPackage" [hideDescription]="true" key="chatConfig"></smart-input>
    <smart-input [(model)]="myPackage" [hideDescription]="true" key="devices"></smart-input>
  </div>

  <mat-card appearance="outlined" class="row fields" *ngIf="!myPackage.tweebie.isMaster && !myPackage.isScreenPackage">
    <ng-container *ngIf="myPackage.tweebie.isDestination">
      <ng-container *ngIf="superadmin">
        <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="isWebAppOnly" translationPrefix="packages.tweebie.destination" hintTranslationPrefix="packages.tweebie.destination.hints"></smart-input>
        <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="isComingSoon" translationPrefix="packages.tweebie.destination" hintTranslationPrefix="packages.tweebie.destination.hints"></smart-input>
        <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="isDevOnly" translationPrefix="packages.tweebie.destination" hintTranslationPrefix="packages.tweebie.destination.hints"></smart-input>
        <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="hideAccommodations" translationPrefix="packages.tweebie.destination" hintTranslationPrefix="packages.tweebie.destination.hints"></smart-input>
      </ng-container>

      <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="destinationZips" translationPrefix="packages.tweebie.destination" hintTranslationPrefix="packages.tweebie.destination.hints"></smart-input>
      <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="tags" translationPrefix="packages.tweebie.destination" hintTranslationPrefix="packages.tweebie.destination.hints"></smart-input>
      <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="radiusMaxRange" translationPrefix="packages.tweebie.destination" hintTranslationPrefix="packages.tweebie.destination.hints"></smart-input>
      <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="radiusDefault" translationPrefix="packages.tweebie.destination" hintTranslationPrefix="packages.tweebie.destination.hints"></smart-input>
      <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="webQRCodeBase" translationPrefix="packages.tweebie.destination" hintTranslationPrefix="packages.tweebie.destination.hints"></smart-input>
      <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="redirectUrl" translationPrefix="packages.tweebie.destination" hintTranslationPrefix="packages.tweebie.destination.hints"></smart-input>
    </ng-container>
    <ng-container *ngIf="!myPackage.tweebie.isDestination && !myPackage.tweebie.isMaster && !myPackage.isScreenPackage">
      <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="disabledWebApp" translationPrefix="packages.tweebie.accommodation" hintTranslationPrefix="packages.tweebie.accommodation.hints"></smart-input>
      <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="inheritQRCodeFromDestination" translationPrefix="packages.tweebie.accommodation" hintTranslationPrefix="packages.tweebie.accommodation.hints"></smart-input>
      <div>
        <p>{{ 'packages.tweebie.accommodation.selectDestination' | translate }}</p>
        <div class="select-wrapper">
          <mat-select [(ngModel)]="myPackage.tweebie.destinationId" [disabled]="destinationPackages.length === 0" placeholder="{{'packages.tweebie.accommodation.selectDestination' | translate}}">
            <mat-option *ngFor="let package of destinationPackages" [value]="package._id">{{ package.title }}</mat-option>
            <mat-option [value]=null>none</mat-option>
          </mat-select>
        </div>
      </div>

      <div>
        <p>{{ 'packages.tweebie.accommodation.selectHS' | translate }}</p>
        <div class="select-wrapper">
          <mat-select [(ngModel)]="myPackage.tweebie.matchIds['hotellerie-suisse']" [disabled]="hotelData.length === 0" placeholder="{{'packages.tweebie.accommodation.selectHS' | translate}}">
            <mat-option [value]=""><b>None</b></mat-option>
            <mat-option *ngFor="let hotel of hotelData" [value]="hotel.id">
              <b>{{ hotel.name }}</b>
              <span *ngIf="hotel.addresses && hotel.addresses.length">- {{ hotel.addresses[0].city }}</span>
            </mat-option>
          </mat-select>
        </div>
      </div>

      <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="accommodationType"
                   translationPrefix="packages.tweebie.accommodation"
                   hintTranslationPrefix="packages.tweebie.accommodation.hints"></smart-input>

      <smart-input (onChange)="addToMatchIds($event, 'stcId')" [(model)]="myPackage" jsonPointerKey="/tweebie" key="stcId"
                   translationPrefix="packages.tweebie.accommodation"
                   hintTranslationPrefix="packages.tweebie.accommodation.hints"></smart-input>

      <smart-input (onChange)="addToMatchIds($event, 'bookingLink')" [(model)]="myPackage" jsonPointerKey="/tweebie" key="bookingLink"
                   translationPrefix="packages.tweebie.accommodation"
                   hintTranslationPrefix="packages.tweebie.accommodation.hints"></smart-input>

      <smart-input *ngIf="!myPackage.tweebie.inheritQRCodeFromDestination" [(model)]="myPackage" jsonPointerKey="/tweebie"
                   key="webQRCodeBase" translationPrefix="packages.tweebie.accommodation"
                   hintTranslationPrefix="packages.tweebie.accommodation.hints"></smart-input>
      <smart-input [(model)]="myPackage" jsonPointerKey="/tweebie" key="redirectUrl" translationPrefix="packages.tweebie.accommodation"
                   hintTranslationPrefix="packages.tweebie.accommodation.hints"></smart-input>
    </ng-container>
  </mat-card>

  <smart-input *ngIf="myPackage.tweebie.isMaster" [(model)]="myPackage" jsonPointerKey="/tweebie"
               key="destinationSelectionConfiguration"></smart-input>

  <ng-container *ngIf="assignedItemsProvider">
    <div *ifPrivilege="{name: 'read', value: 'compositions'}">
      <div class="compositions">
        <div class="available">
          <h3>Available compositions</h3>
          <data-table (detail)="assignItem($event)" [columns]="columns" [dataProvider]="compositionService"></data-table>
        </div>

        <div class="assigned">
          <h3>Assigned compositions</h3>
          <data-table #assignedItemsTable (detail)="goToComposition($event)" (remove)="removeAssignedItem($event)" [columns]="columns"
                      [dataProvider]="assignedItemsProvider"></data-table>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="assignedPackagesProvider">
    <div *ifPrivilege="{name: 'read', value: 'packages'}">
      <div class="compositions">
        <div class="available">
          <h3>Available packages</h3>
          <data-table (detail)="assignPackage($event)" [columns]="columns" [dataProvider]="packageService"></data-table>
        </div>

        <div class="assigned">
          <h3>Assigned child packages</h3>
          <data-table #assignedPackagesTable (detail)="goToComposition($event)" (remove)="removeAssignedPackage($event)" [columns]="columns"
                      [dataProvider]="assignedPackagesProvider"></data-table>
        </div>
      </div>
    </div>
  </ng-container>
  <button (click)="savePackage()" color="primary" mat-raised-button>Save</button>
</page-content>
